import "./DsgvoPage.scss";
import AppContainer from "../../../components/app-container/AppContainer";
import { Trans, useTranslation } from "react-i18next";
import React from "react";

interface TextBlock {
    HEADLINE: string;
    HEADLINE2: string;
    TEXT: string;
}

export const DsgvoPage = () => {
    const { t } = useTranslation();

    const block = t("DSGVO.BLOCK", { returnObjects: true }) as TextBlock[];

    return (
        <>
            <AppContainer header={{ menuLoginEnabled: false }}>
                <div className={"dsgvo-page"}>
                    <h1>{t("DSGVO.HEADLINE")}</h1>
                    {block.map((textBlock, index) => (
                        <section key={index}>
                            <h3>{textBlock.HEADLINE}</h3>

                            <Trans i18nKey={`DSGVO.${index}.TEXT`} components={{ a: <a /> }}>
                                {/* Fallback content in case translation is missing */}
                                {textBlock.TEXT}
                            </Trans>
                            <Trans i18nKey={`DSGVO.${index}.HEADLINE2`}>
                                {/* Fallback content in case translation is missing */}
                                <h2>{textBlock.HEADLINE2}</h2>
                            </Trans>
                        </section>
                    ))}
                </div>
            </AppContainer>
        </>
    );
};
